export const data = [
 {
   "ФИО": "Абдаллах Нуар,\n Бибердорф Элина Арнольдовна",
   "Место работы (учебы)": "Новосибирск, НГУ, ИМ СО РАН",
   "Название доклада": "ИССЛЕДОВАНИЕ АЛГОРИТМОВ ПОСТРОЕНИЯ СПЕКТРАЛЬНЫХ ПОРТРЕТОВ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Абдивохидов Азамат Авазхон угли",
   "Место работы (учебы)": "Узбекистан, Самарканд, СамГУ",
   "Название доклада": "О МОДИФИЦИРОВАННОМ УРАВНЕНИИ КОРТЕВЕГА–ДЕ ФРИЗА–ЛИУВИЛЛЯ ОТРИЦАТЕЛЬНОГО ПОРЯДКА",
   "Секция": "СТО"
 },
 {
   "ФИО": "Абдрахманов Айдар Максутович, Абдрахманова Римма Петровна",
   "Место работы (учебы)": "Уфа, ИРО РБ, УУНиТ",
   "Название доклада": "РАЗРЕШИМОСТЬ КРАЕВЫХ ЗАДАЧ ДЛЯ ЭЛЛИПТИЧЕСКИХ СИСТЕМ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Абдрахманов Самат Илдусович",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "НОВЫЕ ТОЧНЫЕ РЕШЕНИЯ НЕЛИНЕЙНОГО УРАВНЕНИЯ ТЕПЛОПРОВОДНОСТИ И ГОРЕНИЯ С ДЕТЕРМИНИРОВАННЫМ ИЛИ СЛУЧАЙНЫМ ИСТОЧНИКОМ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Абдуллаев Обид, \n Бутаев Русдан Бурибойевич",
   "Место работы (учебы)": "Узбекистан, Самарканд, Самаркандский госуниверситет,  Джизак, ДжПИ",
   "Название доклада": "Смешанная схема метода конечных\n  элементов в решении линейных \n краевых задач теории упругости",
   "Секция": "ММ"
 },
 {
   "ФИО": "Алмохамед Муатаз, Тихонов Иван Владимирович",
   "Место работы (учебы)": "Москва, МТУСИ, МГУ имени М.В. Ломоносова",
   "Название доклада": "ЕДИНСТВЕННОСТЬ РЕШЕНИЯ В ОБРАТНЫХ ЗАДАЧАХ С ПЕРЕОПРЕДЕЛЕНИЯМИ ВЫСОКОГО ПОРЯДКА",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Апушкинская Дарья Евгеньевна",
   "Место работы (учебы)": "Москва, РУДН",
   "Название доклада": "АПОСТЕРИОРНЫЙ АНАЛИЗ ЗАДАЧИ С ТОНКИМ ПРЕПЯТCТВИЕМ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Асхабов Султан Нажмудинович",
   "Место работы (учебы)": "Грозный, ЧГУ имени А.А. Кадырова",
   "Название доклада": "УРАВНЕНИЯ С ИНТЕГРАЛАМИ ДРОБНОГО ПОРЯДКА ВЕЙЛЯ И МОНОТОННОЙ НЕЛИНЕЙНОСТЬЮ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Баззаев Александр Казбекович",
   "Место работы (учебы)": "Владикавказ, North-Ossetian State University",
   "Название доклада": "О РАЗНОСТНОМ РЕШЕНИИ ОДНОЙ ЗАДАЧИ ДЛЯ ПАРАБОЛИЧЕСКОГО УРАВНЕНИЯ С НЕЛОКАЛЬНЫМ ГРАНИЧНЫМ УСЛОВИЕМ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Байков Виталий Анварович, Насырова Дина Ахметовна",
   "Место работы (учебы)": "Уфа, РН-БашНИПИнефть, Уфимский университет науки и технологий",
   "Название доклада": "РЕЖИМЫ ТЕЧЕНИЯ ФЛЮИДА В СИСТЕМЕ «ТРЕЩИНА ГРП-ТРЕЩИНОВАТО-ПОРИСТЫЙ ПЛАСТ» ПРИ ГИДРАВЛИЧЕСКОМ РАЗРЫВЕ ПЛАСТА",
   "Секция": "ММ"
 },
 {
   "ФИО": "Баландин Сергей Павлович, \nТерешкин Владимир Михайлович",
   "Место работы (учебы)": "Уфа, Уфимский университет науки и технологий",
   "Название доклада": "МАТЕМАТИЧЕСКАЯ МОДЕЛЬ ПРОСТРАНСТВЕННО-ВРЕМЕННЫХ ПРОЦЕССОВ В МНОГОФАЗНОЙ ЭЛЕКТРОМЕХАНИЧЕСКОЙ СИСТЕМЕ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Баранов Николай Алексеевич",
   "Место работы (учебы)": "Москва, ВЦ ФИЦ ИУ РАН",
   "Название доклада": "ИНТЕРПОЛЯЦИЯ ДАННЫХ ИЗМЕРЕНИЙ ПРИЗЕМНОЙ КОНЦЕНТРАЦИИ ЗАГРЯЗНЯЮЩИХ ВЕЩЕСТВ С УЧЕТОМ ЛОКАЛЬНОЙ СКОРОСТИ ВЕТРА",
   "Секция": "ММ"
 },
 {
   "ФИО": "Бегматов Акрам Хасанович, Исмоилов Алишер Сидикович",
   "Место работы (учебы)": "Узбекистан, Ташкент, ТГТУ, Самарканд, СамГПИ",
   "Название доклада": "ОБРАТНАЯ ЗАДАЧА ИНТЕГРАЛЬНОЙ ГЕОМЕТРИИ В ТРЕХМЕРНОЙ ПАРАБОЛОИДАЛЬНОЙ ОБЛАСТИ: ФОРМУЛА ОБРАЩЕНИЯ И УСТОЙЧИВОСТЬ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Белова А.С.",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "АСИМПТОТИЧЕСКИЙ АНАЛИЗ И УСТОЙЧИВОСТЬ В\n ЗАДАЧЕ О ПАРАМЕТРИЧЕСКОМ РЕЗОНАНСЕ ДЛЯ\n ЛИНЕЙНЫХ ГАМИЛЬТОНОВЫХ СИСТЕМ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Бондарев Андрей Сергеевич,\nПетрова Анастасия Александровна,\nПировских Олег Михайлович",
   "Место работы (учебы)": "Воронеж, ВГУ",
   "Название доклада": "ПРИБЛИЖЁННОЕ РЕШЕНИЕ МЕТОДОМ ГАЛЁРКИНА ПАРАБОЛИЧЕСКОГО УРАВНЕНИЯ С НЕЛОКАЛЬНЫМ ПО ВРЕМЕНИ УСЛОВИЕМ НА РЕШЕНИЕ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Валеев Нурмухамет Фуатович",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН",
   "Название доклада": "ОПТИМИЗАЦИОННАЯ ОБРАТНАЯ СПЕКТРАЛЬНАЯ ЗАДАЧА ДЛЯ ТРЕХМЕРНОГО ОПЕРАТОРА ШРЕДИНГЕРА",
   "Секция": "СТО"
 },
 {
   "ФИО": "Валеева Д.Н., Носов М.А.",
   "Место работы (учебы)": "Москва, МГУ",
   "Название доклада": "ЧИСЛЕННЫЕ МОДЕЛИ КОЛЕБАНИЙ ВОДЫ В\n ЕСТЕСТВЕННЫХ ВОДОЕМАХ С ПРОИЗВОЛЬНОЙ\n БАТИМЕТРИЕЙ НА ОСНОВЕ ПОТЕНЦИАЛЬНОЙ\n ТЕОРИИ.",
   "Секция": "ММ"
 },
 {
   "ФИО": "Ван Ли",
   "Место работы (учебы)": "Новосибирск, Новосибирский Государственный Университет",
   "Название доклада": "УСТОЙЧИВОСТЬ РЕШЕНИЙ НАЧАЛЬНО-КРАЕВЫХ ЗАДАЧ И СПЕКТРАЛЬНЫЕ ПЯТНА ДИФФЕРЕНЦИАЛЬНОГО ОПЕРАТОРА",
   "Секция": "СТО"
 },
 {
   "ФИО": "Васильев Владимир Борисович, Клименко Иван Иванович, Сопова Татьяна Владимировна",
   "Место работы (учебы)": "Белгород, НИУ \"БелГУ\"",
   "Название доклада": "О РЕШЕНИЯХ ЭЛЛИПТИЧЕСКОГО ПСЕВДОДИФФЕРЕНЦИАЛЬНОГО УРАВНЕНИЯ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Вдовина В.А.",
   "Место работы (учебы)": "",
   "Название доклада": "МАТЕМАТИЧЕСКОЕ МОДЕЛИРОВАНИЕ ПРОЦЕССОВ АДДИТИВНОГО ИЗГОТОВЛЕНИЯ: ПРИМЕНЕНИЕ ДИФФЕРЕНЦИАЛЬНЫХ УРАВНЕНИЙ И СПЕКТРАЛЬНЫХ МЕТОДОВ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Вильданова Венера Фидарисовна",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН",
   "Название доклада": "ОБ ИНТЕГРО-ДИФФЕРЕНЦИАЛЬНОМ УРАВНЕНИИ АГРЕГАЦИИ НА РИМАНОВОМ МНОГООБРАЗИИ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Гаврилов Олег Алексеевич",
   "Место работы (учебы)": "Москва, МГУ имени М.В. Ломоносова",
   "Название доклада": "О ПРИМЕНИМОСТИ МЕТОДА ИТЕРАЦИЙ ДЛЯ ДВУХТОЧЕЧНОЙ ОБРАТНОЙ ЗАДАЧИ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Гадзова Луиза Хамидбиевна",
   "Место работы (учебы)": "Нальчик Институт прикладной математики и автоматизации КБНЦ РАН",
   "Название доклада": "Обобщенная краевая задача для дифференциального уравнения второго порядка",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Гайсин Ахтяр Магазович, Гайсина Галия Ахтяровна",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН, УУНиТ",
   "Название доклада": "ПОРЯДКИ РЯДА ДИРИХЛЕ, СХОДЯЩЕГОСЯ В ПОЛУПЛОСКОСТИ, В ПОЛУПОЛОСАХ",
   "Секция": "КФА"
 },
 {
   "ФИО": "Гайсин Рашит Ахтярович",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН",
   "Название доклада": "КРИТЕРИЙ ИНТЕРПОЛЯЦИОННОСТИ ТИПА ПАВЛОВА-КОРЕВАРА-ДИКСОНА ДЛЯ ВЕЩЕСТВЕННЫХ УЗЛОВ",
   "Секция": "КФА"
 },
 {
   "ФИО": "Галиакбарова Эмилия Вильевна, \n Каримова Гульназ Римовна",
   "Место работы (учебы)": "Уфа, УГНТУ, ИМех УФИЦ РАН",
   "Название доклада": "АНАЛИЗ ДИНАМИКИ УПРУГИХ ВОЛН В ПОРИСТЫХ СРЕДАХ, НАСЫЩЕННЫХ ГАЗОГИДРАТАМИ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Гарифуллин Рустем Наилевич",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН",
   "Название доклада": "О РЕШЕНИИ УРАВНЕНИЯ КУДАШЕВА",
   "Секция": "НУ"
 },
 {
   "ФИО": "Гильманов А.Я., Плисова Д.Э.,\n Шевелев А.П.",
   "Место работы (учебы)": "",
   "Название доклада": "АНАЛИЗ ВЛИЯНИЯ ИНТЕНСИВНОСТЕЙ МАССООБМЕНА ПРИ МОДЕЛИРОВАНИИ ПРОЦЕССА ВНУТРИПЛАСТОВОГО ГОРЕНИЯ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Гильманов Александр Янович, Скобликов Родион Максимович, Федоров Константин Михайлович,\n Шевелёв Александр Павлович",
   "Место работы (учебы)": "Тюмень, Тюменский институт нефти и газа",
   "Название доклада": "Апробация прокси-модели процесса парогравитационного дренажа",
   "Секция": "ММ"
 },
 {
   "ФИО": "Гималтдинова Альфира Авкалевна, Абдрахимова Карина Робертовна",
   "Место работы (учебы)": "Уфа, УГНТУ",
   "Название доклада": "О РЕШЕНИИ НЕКОТОРЫХ ТРАНСЦЕНДЕНТНЫХ УРАВНЕНИЙ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Глазатов Владимир Андреевич",
   "Место работы (учебы)": "Долгопрудный, МФТИ",
   "Название доклада": "БАНАХОВА МЕРА НА ГИЛЬБЕРТОВОМ ПРОСТРАНСТВЕ",
   "Секция": "КФА"
 },
 {
   "ФИО": "Гладун Алексей Владимирович",
   "Место работы (учебы)": "Ульяновск, УИГА",
   "Название доклада": "ОБ УПРАВЛЕНИИ НЕЛИНЕЙНОЙ СИСТЕМОЙ В ОКРЕСТНОСТИ ПОЛОЖЕНИЯ РАВНОВЕСИЯ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Гончаров Никита Сергеевич, Китаева Ольга Геннадьевна, Свиридюк Георгий Анатольевич",
   "Место работы (учебы)": "Челябинск, ЮУрГУ",
   "Название доклада": "ОБ ОДНОЙ ЗАДАЧЕ СТАБИЛИЗАЦИИ РЕШЕНИЙ СТОХАСТИЧЕСКОЙ ФИЛЬТРАЦИОННОЙ СИСТЕМЫ ВЕНТЦЕЛЯ В КРУГЕ И НА ЕГО ГРАНИЦЕ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Гребенникова Ирина Владимировна",
   "Место работы (учебы)": "Екатеринбург, УГГУ",
   "Название доклада": "ОБ УПРАВЛЕНИИИ ДИНАМИЧЕСКОЙ СИСТЕМОЙ С ЗАПАЗДЫВАНИЕМ ПРИ ИНТЕГРАЛЬНЫХ ОГРАНИЧЕНИЯХ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Гусаков Г. К., Гильманов А Я.,\nШевелев А.П.",
   "Место работы (учебы)": "Тюмень, ООО «НОВАТЭК НТЦ»",
   "Название доклада": "МЕТОДИКА ОБЪЕДИНЕНИЯ ТЯЖЕЛЫХ УГЛЕВОДОРОДОВ В ПСЕВДОКОМПОНЕНТ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Даллул Мариана, Жалуд Исса",
   "Место работы (учебы)": "Казань, КФУ",
   "Название доклада": "ХАРАКТЕРИЗАЦИЯ СЛЕДОВЫХ ФУНКЦИОНАЛОВ НА АЛГЕБРЕ ФОН НЕЙМАНА НЕРАВЕНСТВАМИ ДЛЯ СТЕПЕННЫХ ФУНКЦИЙ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Дарвиш Т.М.Ф.",
   "Место работы (учебы)": "Казань, Казанский (Приволжский) федеральный университет, Институт математики и механики им. Н.И. Лобачевского",
   "Название доклада": "ОПЕРАТОР БЛОЧНОГО ПРОЕКТИРОВАНИЯ НА АЛГЕБРЕ ИЗМЕРИМЫХ ОПЕРАТОРОВ",
   "Секция": "КФА"
 },
 {
   "ФИО": "Дармаева Аяна Алдаровна, Орлов Сергей Сергеевич",
   "Место работы (учебы)": "Иркутск, ИГУ",
   "Название доклада": "ВЕЩЕСТВЕННОЗНАЧНЫЕ ОБЩИЕ РЕШЕНИЯ ФУНКЦИОНАЛЬНЫХ УРАВНЕНИЙ С ОПЕРАТОРОМ ПОДОБИЯ АРГУМЕНТА ИСКОМОЙ ФУНКЦИИ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Дженжер Святослав Вадимович,\nСакбаев Всеволод Жанович",
   "Место работы (учебы)": "Долгопрудный, МФТИ,\n Москва, ИПМ им.М.В.Келдыша РАН",
   "Название доклада": "Усиленный Закон Больших Чисел для случайных полугрупп на равномерно гладких банаховых пространствах",
   "Секция": "СТО"
 },
 {
   "ФИО": "Доброхотов Сергей Юрьевич",
   "Место работы (учебы)": "Москва, ИПМех РАН",
   "Название доклада": "НЕКОМПАКТНЫЕ ЛАГРАНЖЕВЫ МНОГООБРАЗИЯ И АСИМПТОТИЧЕСКИЕ СОБСТВЕННЫЕ ФУНКЦИИ ОПЕРАТОРА ЛАПЛАСА В ЭЛЛИПСЕ, СВЯЗАННЫЕ С БИЛЬЯРДАМИ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Евхута Николай Александрович, Евхута Ольга Николаевна",
   "Место работы (учебы)": "Новочеркасск, ЮРГПУ (НПИ) им. М.И. Платова",
   "Название доклада": "О СПЕКТРАЛЬНЫХ СВОЙСТВАХ ЛИНЕЙНОГО ИНТЕГРАЛЬНОГО ОПЕРАТОРА С ПОЛОЖИТЕЛЬНЫМ ЯДРОМ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Заворохин Герман Львович, Мацковский Андрей Александрович",
   "Место работы (учебы)": "Санкт-Петербург, ПОМИ РАН",
   "Название доклада": "Об упругих волнах в топографических волноводах",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Зайнуллин Рифат Гильметдинович",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "ДВУХМЕРНАЯ ОДНОФАЗНАЯ ЗАДАЧА ТЕПЛООБМЕНА С ФАЗОВЫМ ПЕРЕХОДОМ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Зотова Екатерина Игоревна",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "ОБ ОБОБЩЕННОМ УРАВНЕНИИ КОРТЕВЕГА-ДЕ ВРИЗА-БЮРГЕРСА С ВРЕМЕННЫМ ШУМОМ В ДИСПЕРСИОННОМ ЧЛЕНЕ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Иванова Ольга Александровна",
   "Место работы (учебы)": "Ростов-на-Дону, Южный федеральный университет",
   "Название доклада": "Представления операторов Эйлера бесконечного порядка и числа Стирлинга",
   "Секция": "КФА"
 },
 {
   "ФИО": "Игнатьев Михаил Юрьевич",
   "Место работы (учебы)": "Саратов, СГУ",
   "Название доклада": "О ФУНДАМЕНТАЛЬНЫХ ТЕНЗОРАХ, СВЯЗАННЫХ С ДИФФЕРЕНЦИАЛЬНЫМИ ОПЕРАТОРАМИ ВЫСШИХ ПОРЯДКОВ С ОСОБЕННОСТЬЮ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Ильина Кюннэй Павловна,\n Васильев Василий Иванович",
   "Место работы (учебы)": "Якутск, Институт математики и информатики, Северо-Восточный федеральный университет,\n Якутск, Северо-Восточный федеральный университет",
   "Название доклада": "Численные эксперименты для задач типа «бегущей волны»: от уравнения Баклея–Леверетта до Колмогорова-Петровского-Пискунова(Фишера)",
   "Секция": "ММ"
 },
 {
   "ФИО": "Исмагилов Рузель Фанилевич, Луценко Владимир Иванович",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "АВТОМАТИЗАЦИЯ ОБРАБОТКИ ДАННЫХ С ДАТЧИКОВ И ИДЕНТИФИКАЦИЯ СХЕМНЫХ ЭЛЕМЕНТОВ НА ОСНОВЕ ИЗОБРАЖЕНИЙ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Ишкин Хабир Кабирович",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "КРИТЕРИЙ СУЩЕСТВОВАНИЯ ТРЕУГОЛЬНОГО ОПЕРАТОРА ПРЕОБРАЗОВАНИЯ ДЛЯ ДВУЧЛЕННЫХ ДИФФЕРЕНЦИАЛЬНЫХ УРАВНЕНИЙ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Кабанко Михаил Владимирович",
   "Место работы (учебы)": "Курск, Курский госуниверситет",
   "Название доклада": "ОЦЕНКИ НАИЛУЧШИХ ПРИБЛИЖЕНИЙ ЦЕЛЫХ ФУНКЦИЙ В НЕКОТОРЫХ БАНАХОВЫХ ПРОСТРАНСТВАХ",
   "Секция": "КФА"
 },
 {
   "ФИО": "Кабанов Даниил Константинович, Фахретдинов Марат Ирекович, Екомасов Евгений Григорьевич",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "ЛОКАЛИЗОВАННЫЕ ВОЛНЫ УРАВНЕНИЯ ϕ4 В МОДЕЛИ С ПРИМЕСЯМИ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Какушкин Сергей Николаевич",
   "Место работы (учебы)": "Белорецк, АО „БМК“",
   "Название доклада": "ПРОСТЫЕ ФОРМУЛЫ НАХОЖДЕНИЯ СОБСТВЕННОЙ ФУНКЦИИ ВОЗМУЩЕННЫХ САМОСОПРЯЖЕННЫХ ОПЕРАТОРОВ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Касперович Антон Михайлович",
   "Место работы (учебы)": "Тюмень, ООО «Газпром ВНИИГАЗ», ТюмГУ",
   "Название доклада": "Построение сопряженной геомеханической и гидродинамической модели роста трещины автогидроразрыва пласта в результате кольматации границ трещины",
   "Секция": "ММ"
 },
 {
   "ФИО": "Клевцова Юлия Юрьевна",
   "Место работы (учебы)": "Новосибирск, ИСИ СО РАН, СибГУТИ",
   "Название доклада": "ОБ ОДНОМ НЕРАВЕНСТВЕ НА РЕШЕНИЯ БАРОКЛИННОЙ МОДЕЛИ АТМОСФЕРЫ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Клячин Алексей Александрович, Бичерахова Ольга Сергеевна",
   "Место работы (учебы)": "Волгоград, ВолГУ",
   "Название доклада": "КУСОЧНО-ЛИНЕЙНЫЕ РЕШЕНИЯ КРАЕВЫХ ЗАДАЧ И ВЛИЯНИЕ НА ИХ ПОГРЕШНОСТЬ РАЗЛИЧНЫХ ПОКАЗАТЕЛЕЙ КАЧЕСТВА ТРЕУГОЛЬНОЙ СЕТКИ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Кожевникова Лариса Михайловна",
   "Место работы (учебы)": "Стерлитамак, СФ УУНиТ",
   "Название доклада": "УСТРАНИМЫЕ ОСОБЕННОСТИ РЕШЕНИЙ АНИЗОТРОПНЫХ ЭЛЛИПТИЧЕСКИХ УРАВНЕНИЙ С ПЕРЕМЕННЫМИ ПОКАЗАТЕЛЯМИ НЕЛИНЕЙНОСТЕЙ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Колонских Денис Михайлович, Морозкин Николай Данилович",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "МАТЕМАТИЧЕСКАЯ КАЛИБРОВКА ГРАДИЕНТОМЕТРА МАГНИТНОГО ПОЛЯ НА ОСНОВЕ ПАРНОЙ АППРОКСИМАЦИИ ХАРАКТЕРИСТИК ТРЁХОСНЫХ ФЛЮКСГЕЙТ-МАГНИТОМЕТРОВ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Костин Андрей Борисович",
   "Место работы (учебы)": "Москва, МГУ им. М.В. Ломоносова",
   "Название доклада": "Формула Бине и задача о поведении гамма-функции на мнимой оси",
   "Секция": "КФА"
 },
 {
   "ФИО": "Крючкина Н.С.",
   "Место работы (учебы)": "",
   "Название доклада": "ИСПОЛЬЗОВАНИЕ МАТЕМАТИЧЕСКОГО МОДЕЛИРОВАНИЯ В МЕДИЦИНЕ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Кудрявцева Ольга Сергеевна",
   "Место работы (учебы)": "Москва, МГУ им. М.В.Ломоносова",
   "Название доклада": "Экстремальные оценки и геометрические характеристики голоморфных отображений круга в себя",
   "Секция": "КФА"
 },
 {
   "ФИО": "Кузьмин Игорь Леонидович, Шайхиев Эрик Радикович, Биткулов Марат Дамирович, Макаров Максим Игоревич, Муртазина Регина Димовна",
   "Место работы (учебы)": "Москва, МГТУ им. Н.Э. Баумана, НИУ ВШЭ, МФТИ, НИУ ВШЭ, \n Уфа, УУНиТ",
   "Название доклада": "РАСПРЕДЕЛЕНИЕ ТЕМПЕРАТУРЫ В ОДНОМЕРНОЙ ПЛИТЕ С ИСТОЧНИКОМ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Кунгиров М.Н.",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "БИФУРКАЦИЯ ЦИКЛОВ В ГАМИЛЬТОНОВЫХ\n СИСТЕМАХ С МАЛЫМ ПАРАМЕТРОМ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Леушин Н.В., Шевелев А.П., Гильманов А.Я.",
   "Место работы (учебы)": "",
   "Название доклада": "АНАЛИЗ ЭФФЕКТИВНОСТИ РАЗРАБОТКИ НЕФТЯНЫХ ПЛАСТОВ ГОРИЗОНТАЛЬНЫМИ СКВАЖИНАМИ РАЗЛИЧНЫХ КОНСТРУКЦИЙ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Литвинова Кристина Владиславовна, Литвинов Владислав Львович",
   "Место работы (учебы)": "Москва, МГУ им. М.В.Ломоносова, \n Самара, СФ СамГТУ",
   "Название доклада": "Construction of analytical approximations for calculating phase equilibrium constants in PVT modeling of oil and gas condensate fields",
   "Секция": "ММ"
 },
 {
   "ФИО": "Лушина Екатерина Александровна",
   "Место работы (учебы)": "Воронеж, ВГУ",
   "Название доклада": "О РЕЛЬСОВОМ ЦЕЛОУДАЛЕННОМ МНОЖЕСТВЕ С ЧЁТНЫМ ОСНОВАНИЕМ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Макаров Валерий Николаевич,\nШестопалов Павел Иванович",
   "Место работы (учебы)": "Оренбург, Оренбургский госуниверситет,\nСанкт-Петербург, СПбГУ",
   "Название доклада": "ТОПОЛОГИЧЕСКАЯ СТРУКТУРА ВИХРЕВЫХ ТОКОВ И ЕЕ ФИЗИЧЕСКАЯ ИНТЕРПРЕТАЦИЯ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Макин Александр Сергеевич",
   "Место работы (учебы)": "Донецк, ИПММ",
   "Название доклада": "О СХОДИМОСТИ СПЕКТРАЛЬНЫХ РАЗЛОЖЕНИЙ, ОТВЕЧАЮЩИХ ОПЕРАТОРУ ДИРАКА С ДВУХТОЧЕЧНЫМИ КРАЕВЫМИ УСЛОВИЯМИ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Малютин Виктор Борисович,\n Нуржанов Бердах Орынбаевич",
   "Место работы (учебы)": "Белоруссия, Минск, Институт математики НАН Беларуси,\n Узбекистан, Ташкент, Институт математики имени В.И. Романовского АН Республики Узбекистан",
   "Название доклада": "Вычисление характеристик стохастических дифференциальных уравнений с помощью квазиклассической аппроксимации",
   "Секция": "ММ"
 },
 {
   "ФИО": "Малютин Константин Геннадьевич",
   "Место работы (учебы)": "Курск, Курский государственный университет",
   "Название доклада": "ДЕЛЬТА-СУБГАРМОНИЧЕСКИЕ ФУНКЦИИ ВПОЛНЕ РЕГУЛЯРНОГО РОСТА В НЕОГРАНИЧЕННОМ ПОЛУКОЛЬЦЕ",
   "Секция": "КФА"
 },
 {
   "ФИО": "Маматов Акмал Равшанович",
   "Место работы (учебы)": "Узбекистан, Самарканд, Самаркандский госуниверситет",
   "Название доклада": "Алгоритм решения одной игры связанной с задачей перевода траектории динамической системы",
   "Секция": "ММ"
 },
 {
   "ФИО": "Маматов Акмал Равшанович,\n Абдуллаев Обид",
   "Место работы (учебы)": "Узбекистан, Самарканд, Самаркандский госуниверситет",
   "Название доклада": "Алгоритм построения решений в параллелепипеде системы линейных уравнений",
   "Секция": "ММ"
 },
 {
   "ФИО": "Мануйлов Владимир Маркович",
   "Место работы (учебы)": "Москва, МГУ им. М.В. Ломоносова",
   "Название доклада": "Метрики на дублях как инверсная полугруппа",
   "Секция": "КФА"
 },
 {
   "ФИО": "Масаева Олеся Хажисмеловна",
   "Место работы (учебы)": "Нальчик, ИПМА КБНЦ РАН",
   "Название доклада": "СМЕШАННАЯ ЗАДАЧА С ДАННЫМИ НА ВСЕЙ ГРАНИЦЕ ДЛЯ ОБОБЩЕННОГО УРАВНЕНИЯ ЛАПЛАСА",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Маслов Дмитрий Александрович",
   "Место работы (учебы)": "Москва, НИУ МЭИ",
   "Название доклада": "Аналитические по малому параметру решения слабо нелинейных задач специального вида",
   "Секция": "НУ"
 },
 {
   "ФИО": "Мелихов Сергей Николаевич",
   "Место работы (учебы)": "Ростов-на-Дону, Южный федеральный университет, Южный математический институт ВНЦ РАН",
   "Название доклада": "Структура локальной алгебры в пространстве всех функций, голоморфных в многомерной области",
   "Секция": "КФА"
 },
 {
   "ФИО": "Мехаев Сергей Андреевич, Гильманов Александр Янович, Шевелёв Александр Павлович",
   "Место работы (учебы)": "Тюмень, ТюмГУ",
   "Название доклада": "РЕШЕНИЕ ОБРАТНОЙ ФИЛЬТРАЦИОННОЙ ЗАДАЧИ В МАСШТАБАХ КЕРНА",
   "Секция": "ММ"
 },
 {
   "ФИО": "Мищенко Александр Сергеевич",
   "Место работы (учебы)": "Москва, МГУ им. М.В.Ломоносова",
   "Название доклада": "Когомологии симплициальных пространств\n с промежуточными носителями в смысле Е.Г.Скляренко",
   "Секция": "КФА"
 },
 {
   "ФИО": "Мелехина Дарья Владимировна,\n Федоров Владимир Евгеньевич",
   "Место работы (учебы)": "Челябинск, ЧелГУ",
   "Название доклада": "ЗАДАЧА ИДЕНТИФИКАЦИИ С ПЕРЕМЕННЫМ НЕИЗВЕСТНЫМ ПАРАМЕТРОМ В СЕКТОРИАЛЬНОМ СЛУЧАЕ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Мирзоев Карахан Агахан оглы",
   "Место работы (учебы)": "Москва, МГУ",
   "Название доклада": "ЛАКУНАРНЫЕ РЕКУРРЕНТНЫЕ СООТНОШЕНИЯ С ПРОПУСКАМИ ПРОИЗВОЛЬНОЙ ЧЁТНОЙ ДЛИНЫ ДЛЯ МНОГОЧЛЕНОВ БЕРНУЛЛИ И ЭЙЛЕРА",
   "Секция": "СТО"
 },
 {
   "ФИО": "Морозкин Николай Данилович, Морозкин Никита Николаевич, Галлямов Всеволод Викторович",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "ВЛИЯНИЕ ЗОНЫ РАЗРУШЕНИЯ СТРУКТУРЫ НА ТЕПЛОВЫЕ ПРОЦЕССЫ ПРИ ФИЛЬТРАЦИИ ВЫСОКОВЯЗКОЙ НЕФТИ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Муравник Андрей Борисович,\n Яремко Олег Эммануилович,\n Яремко Наталия Николаевна",
   "Место работы (учебы)": "Москва, РУДН,\n  СТАНКИН,\n  МИСИС",
   "Название доклада": "ЗАДАЧА КОШИ ДЛЯ ГИПЕРБОЛИЧЕСКИХ УРАВНЕНИЙ С НЕЛОКАЛЬНЫМИ ПОТЕНЦИАЛАМИ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Муренков Ярослав Андреевич, Алфимов Георгий Леонидович",
   "Место работы (учебы)": "Зеленоград, Москва,  НИУ МИЭТ,\n Москва,  НИУ МИЭТ, Уфа, ИМВЦ УФИЦ РАН",
   "Название доклада": "ОГРАНИЧЕННЫЕ РЕШЕНИЯ УРАВНЕНИЙ ДЮФФИНГА С ПЕРИОДИЧЕСКИМ ПОТЕНЦИАЛОМ С КОЭФФИЦИЕНТАМИ НЕСОИЗМЕРИМЫХ ПЕРИОДОВ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Мурясов Роман Русланович",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН",
   "Название доклада": "О СУБГАРМОНИЧНОСТИ ФУНКЦИЙ С РАЗДЕЛЁННЫМИ ПЕРЕМЕННЫМИ В КРИВОЛИНЕЙНЫХ СИСТЕМАХ КООРДИНАТ",
   "Секция": "КФА"
 },
 {
   "ФИО": "Мухамадиев Эргашбой Мирзоевич, Нуров Исхокбой Джумаевич, Каримов Мехрубон Маткаримович,\n Убайдов Муртазо Зубайдович",
   "Место работы (учебы)": "Вологда, ВоГУ,\n Душанбе, ТНУ, ТНУ, ТНУ",
   "Название доклада": "КАЧЕСТВЕННЫЙ АНАЛИЗ СУЩЕСТВОВАНИЯ ЦИКЛОВ КУСОЧНО-ЛИНЕЙНЫХ ДИФФЕРЕНЦИАЛЬНЫХ УРАВНЕНИЙ ВТОРОГО ПОРЯДКА",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Напалков Валерий Валентинович, Нуятов Андрей Александрович",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН,\n Нижний Новгород, НГТУ имени Р.Е. Алексеева",
   "Название доклада": "О необходимых условиях эквивалентности одного класса гильбертовых пространств с воспроизводящим ядром",
   "Секция": "КФА"
 },
 {
   "ФИО": "Назимов Акбар Багадурович, Мухамадиев Эргашбой Мирзоевич",
   "Место работы (учебы)": "Таджикистан, Худжанд, ХГУ им. академика Б. Гафурова, Вологда, ВоГУ",
   "Название доклада": "АНАЛОГ ТЕОРЕМЫ ФЕЙЕРА В ПРОСТРАНСТВЕ ГЁЛЬДЕРА",
   "Секция": "КФА"
 },
 {
   "ФИО": "Наумова Алёна Александровна",
   "Место работы (учебы)": "Курск, Курский госуниверситет",
   "Название доклада": "Обобщенная формула Карлемана для полукольца",
   "Секция": "КФА"
 },
 {
   "ФИО": "Нефедова Анна Андреевна",
   "Место работы (учебы)": "Курск, Курский госуниверситет",
   "Название доклада": "Экстремальные задачи в классе мероморфных функций конечного порядка",
   "Секция": "КФА"
 },
 {
   "ФИО": "Новокшенов В.Ю.",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН",
   "Название доклада": "Диссипативные возмущения интегрируемых систем",
   "Секция": "НУ"
 },
 {
   "ФИО": "Олими Абдуманон Гафорзода",
   "Место работы (учебы)": "Таджикистан, Худжанд, ХГУ",
   "Название доклада": "СИСТЕМА ДИФФЕРЕНЦИАЛЬНЫХ УРАВНЕНИЙ ВТОРОГО ПОРЯДКА СО СВЕРХСИНГУЛЯРНОЙ ТОЧКОЙ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Орлова Наталья Романовна",
   "Место работы (учебы)": "Москва, РУДН",
   "Название доклада": "ФОРМУЛА ЛЕФШЕЦА ДЛЯ НЕЛОКАЛЬНЫХ ЭЛЛИПТИЧЕСКИХ ЗАДАЧ, АССОЦИИРОВАННЫХ С РАССЛОЕНИЕМ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Очилова Мухаё Акбаровна, Байзаев Саттор",
   "Место работы (учебы)": "Таджикистан, Худжанд, ХГУ им. академика Б. Гафурова, ТГУПБП",
   "Название доклада": "О РАЗРЕШИМОСТИ ИНТЕГРАЛЬНОГО УРАВНЕНИЯ ГИЛЬБЕРТА ВТОРОГО РОДА СМЕШАННОГО ТИПА",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Павленко Виктор",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН",
   "Название доклада": "ПОСТРОЕНИЕ РЕШЕНИЙ АНАЛОГОВ ВРЕМЕННЫХ УРАВНЕНИЙ ШРЕДИНГЕРА, СООТВЕТСТВУЮЩИХ ГАМИЛЬТОНОВОЙ СИСТЕМЕ  H3+1+1",
   "Секция": "НУ"
 },
 {
   "ФИО": "Павлюк Юрий Алексеевич",
   "Место работы (учебы)": "Барнаул, АлтГПУ",
   "Название доклада": "ИССЛЕДОВАНИЕ ОСОБЕННОСТЕЙ ТЕЧЕНИЙ ПОЛИМЕРНЫХ РАСПЛАВОВ НА ОСНОВЕ МОДЕЛИ ВИНОГРАДОВА-ПОКРОВСКОГО",
   "Секция": "ММ"
 },
 {
   "ФИО": "Панеш Асхад Асланович, Сташ Айдамир Хазретович",
   "Место работы (учебы)": "Майкоп, АГУ",
   "Название доклада": "О НЕПРЕРЫВНОСТИ СКОРОСТЕЙ БЛУЖДАНИЯ И ПОКАЗАТЕЛЕЙ КОЛЕБЛЕМОСТИ НА МНОЖЕСТВЕ ДИФФЕРЕНЦИАЛЬНЫХ СИСТЕМ, ЗАДАЮЩИХ ПОВОРОТЫ ПЛОСКОСТИ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Петрова А. А., Грибанов Д. В., Бондарев А.С.",
   "Место работы (учебы)": "Воронеж, ВГУ",
   "Название доклада": "О СХОДИМОСТИ ПРОЕКЦИОННО-РАЗНОСТНОГО МЕТОДА ДЛЯ ПАРАБОЛИЧЕСКИХ УРАВНЕНИЙ С НЕЛОКАЛЬНЫМ ПО ВРЕМЕНИ УСЛОВИЕМ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Петрова Анна Романовна, \n Сороколетова Ирина Александровна",
   "Место работы (учебы)": "Мытищи, Мытищинский филиал МГТУ имени Н. Э. Баумана",
   "Название доклада": "МОДЕЛИРОВАНИЕ СОБСТВЕННЫХ КОЛЕБАНИЙ КОНСОЛЬНОЙ БАЛКИ В РАМКАХ ГИПОТЕЗЫ БЕРНУЛЛИ-ЭЙЛЕРА И ЕГО ПРИМЕНЕНИЕ К АНАЛИЗУ ДИНАМИКИ КАМЕРТОНА",
   "Секция": "ММ"
 },
 {
   "ФИО": "Плаксина Ирина Михайловна",
   "Место работы (учебы)": "Пермь, ПНИПУ",
   "Название доклада": "О разрешимости одного уравнения с дробными производными",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Подклетнова Светлана Владимировна",
   "Место работы (учебы)": "Самара, Самарский университет",
   "Название доклада": "КРАЕВАЯ ЗАДАЧА ДЛЯ УРАВНЕНИЯ ЭЙЛЕРА-ДАРБУ С ДВУМЯ ЛИНИЯМИ ВЫРОЖДЕНИЯ В ХАРАКТЕРИСТИЧЕСКИХ КООРДИНАТАХ С ТРИВИАЛЬНЫМ КОЭФФИЦИЕНТОМ ПРИ ПРОИЗВОДНОЙ ПО АБСЦИССЕ ОТ ИСКОМОЙ ФУНКЦИИ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Похачевский Всеволод Андреевич, \n Быков Владимир Владиславович",
   "Место работы (учебы)": "Москва, МГУ им. М.В. Ломоносова",
   "Название доклада": "СТАРШИЙ СЛАБЫЙ НИЖНИЙ ПОКАЗАТЕЛЬ КОЛЕБЛЕМОСТИ КОРНЕЙ ПАРАМЕТРИЧЕСКОГО СЕМЕЙСТВА ЛИНЕЙНЫХ ДИФФЕРЕНЦИАЛЬНЫХ СИСТЕМ НА ПЛОСКОСТИ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Починка Ольга Витальевна, Галкин В.Д.",
   "Место работы (учебы)": "Нижний Новгород , НИУ ВШЭ",
   "Название доклада": "Топология 4-многообразий, допускающих неособые потоки с седловыми орбитами одинакового индекса",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Радкевич Е.В.\n Васильева О.А.\n Филиппов Г.А.",
   "Место работы (учебы)": "",
   "Название доклада": "О проблеме стабилизации периодических возмущений положения равновесия для двумерного кинетического уравнения Бродвелла",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Рахимова Алсу Ильдаровна",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН",
   "Название доклада": "Динамические свойства операторов в F_\\phi",
   "Секция": "КФА"
 },
 {
   "ФИО": "Рустанов Алигаджи Рабаданович,\n Харитонова Светлана Владимировна",
   "Место работы (учебы)": "Москва, НИУ МГСУ,\n Оренбург, Оренбургский госуниверситет",
   "Название доклада": "ТЕНЗОР РИЧЧИ ГАРМОНИЧЕСКИХ ПРИБЛИЖЕННО ТРАНССАСАКИЕВЫХ МНОГООБРАЗИЙ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Сакбаев В.Ж.",
   "Место работы (учебы)": "Москва, Институт прикладной математики им. М.В. Келдыша РАН",
   "Название доклада": "Предельные операторные семейства итераций Фейнмана-Чернова",
   "Секция": "СТО"
 },
 {
   "ФИО": "Савчук Артём Маркович,\n Кузнецов Егор Дмитриевич",
   "Место работы (учебы)": "Москва, МГУ им. М.В. Ломоносова",
   "Название доклада": "РЕГУЛЯРИЗОВАННЫЙ СЛЕД ОПЕРАТОРА ШТУРМА–ЛИУВИЛЛЯ НА ГРАФЕ–ЗВЕЗДЕ С ГРАНИЧНЫМИ УСЛОВИЯМИ ДИРИХЛЕ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Савчук Артем Маркович,\n Северцов Станислав Александрович",
   "Место работы (учебы)": "Москва, МГУ им. М.В. Ломоносова",
   "Название доклада": "РЕГУЛЯРИЗОВАННЫЙ СЛЕД ОПЕРАТОРА ШТУРМА–ЛИУВИЛЛЯ С δ–ПОТЕНЦИАЛОМ И СДВИГОМ В АРГУМЕНТЕ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Салимов Ришат Камилевич",
   "Место работы (учебы)": "Уфа, Уфимский университет науки и технологий",
   "Название доклада": "О ЛОРЕНЦ ИНВАРИАНТНЫХ УРАВНЕНИЯХ С БЕСКОНЕЧНЫМ ПОРЯДКОМ ПРОИЗВОДНОЙ, ДОПУСКАЮЩИХ ЛОКАЛИЗОВАННЫЕ РЕШЕНИЯ СО СВЕТОВОЙ СКОРОСТЬЮ И ОСЦИЛЛИРУЮЩЕЙ СО\n ВРЕМЕНЕМ АМПЛИТУДОЙ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Сидоренко Владислав Викторович",
   "Место работы (учебы)": "Москва, ИПМ им.М.В. Келдыша РАН",
   "Название доклада": "Об одной аналитически интегрируемой модели движения небесных тел",
   "Секция": "ММ"
 },
 {
   "ФИО": "Самигуллина Анжела Ильгизовна,\n Шарафуллин Ильдус Фанисович",
   "Место работы (учебы)": "Уфа, Уфимский университет науки и технологий",
   "Название доклада": "Нелинейная динамика спиновых волн: подход на основе двухвременных функций Грина",
   "Секция": "НУ"
 },
 {
   "ФИО": "Саносян А.",
   "Место работы (учебы)": "Тольятти, Тольяттинский госуниверситет",
   "Название доклада": "Математическая модель адаптивного управления строительными проектами в условиях неопределённости и ограниченности ресурсов",
   "Секция": "ММ"
 },
 {
   "ФИО": "Сатторов Эрмамат Норкулович, Эрмаматова Зухро Эрмаматовна, Эрмаматова Бибихожар Эрмаматовна",
   "Место работы (учебы)": "Узбекистан, Самарканд, СамГПИ,\n ZARMED University,\n СамГУ",
   "Название доклада": "DIRECT AND INVERSE NUMERICAL SOLUTION OF THE CAUCHY PROBLEM THREE-DMENSIONAL INHOMOGENEOUUS HELMHOLTZ EQUATION",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Сафонова Татьяна Анатольевна",
   "Место работы (учебы)": "Архангельск, САФУ",
   "Название доклада": "ЗНАЧЕНИЯ ДЗЕТА-ФУНКЦИИ РИМАНА В НЕЧЁТНЫХ ТОЧКАХ И ОБОБЩЁННЫЕ ГИПЕРГЕОМЕТРИЧЕСКИЕ РЯДЫ",
   "Секция": "СТО"
 },
 {
   "ФИО": "Семенов А.Д.",
   "Место работы (учебы)": "",
   "Название доклада": "Периодические автоморфизмы трехмерного тора",
   "Секция": "НУ"
 },
 {
   "ФИО": "Скрипка Надежда Михайловна,\n Федоров Владимир Евгеньевич",
   "Место работы (учебы)": "Челябинск, ЧелГУ",
   "Название доклада": "КРАЕВАЯ ЗАДАЧА ДЛЯ ПСЕВДОПАРАБОЛИЧЕСКОГО УРАВНЕНИЯ С ДРОБНОЙ ПРОИЗВОДНОЙ ЛИУВИЛЛЯ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Солиев Юнус Солиевич",
   "Место работы (учебы)": "Москва, МАДИ",
   "Название доклада": "К ПРИБЛИЖЕННОМУ ВЫЧИСЛЕНИЮ ГИПЕРСИНГУЛЯРНЫХ ИНТЕГРАЛОВ ПО ОТРЕЗКУ ДЕЙСТВИТЕЛЬНОЙ ОСИ",
   "Секция": "КФА"
 },
 {
   "ФИО": "Соловьёва Наталья Николаевна, Свиридюк Георгий Анатольевич, Загребина Софья Александровна,",
   "Место работы (учебы)": "Челябинск, ЮУрГУ (НИУ)",
   "Название доклада": "О ПРАКТИЧЕСКОМ ПРИМЕНЕНИИ ПОЗИТИВНЫХ РЕШЕНИЙ В МАТЕМАТИЧЕСКОМ МОДЕЛИРОВАНИИ ГЕМОДИНАМИКИ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Солодов Алексей Петрович",
   "Место работы (учебы)": "Москва, МГУ \n им. М.В.Ломоносова.",
   "Название доклада": "Условия сходимости алгоритмов жадного типа",
   "Секция": "КФА"
 },
 {
   "ФИО": "Султанов Оскар Анварович",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН",
   "Название доклада": "НЕЛИНЕЙНЫЙ РЕЗОНАНС В СИСТЕМАХ С ИСЧЕЗАЮЩИМИ ОСЦИЛЛИРУЮЩИМИ ВОЗМУЩЕНИЯМИ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Сучкова Дилара Айратовна",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "Об обобщенном стохастическом уравнении Кортевега - де Вриза с временным шумом в нелинейном члене",
   "Секция": "НУ"
 },
 {
   "ФИО": "Талбакзода Фарходджон Махмадшо",
   "Место работы (учебы)": "Таджикистан, Душанбе, ТГПУ",
   "Название доклада": "ОБ АБСОЛЮТНОЙ СХОДИМОСТИ ДВОЙНЫХ РЯДОВ ФУРЬЕ ПОЧТИ-ПЕРИОДИЧЕСКИХ ФУНКЦИЙ",
   "Секция": "КФА"
 },
 {
   "ФИО": "Тахиров Жозил Останович",
   "Место работы (учебы)": "Узбекистан, Ташкент, ИМ АН РУз",
   "Название доклада": "О ПЕРИОДИЧЕСКИХ РЕШЕНИЯХ НЕЛИНЕЙНОЙ МОДЕЛИ ХЕМОТАКСИСА ТИПА КЕЛЛЕРА-СЕГЕЛЯ С ЛОГИСТИЧЕСКИМ ИСТОЧНИКОМ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Ташпулатов Саъдулла Мамаражабович",
   "Место работы (учебы)": "Ташкент, Институт ядерной физики Академии наук республики Узбекистан",
   "Название доклада": "ТРЕХЭЛЕКТРОННОГО ПЕРВОГО ДУБЛЕТА В ПРИМЕСНОЙ МОДЕЛИ ХАББАРДА",
   "Секция": "СТО"
 },
 {
   "ФИО": "Токарев Денис Алексеевич",
   "Место работы (учебы)": "Белгород, НИУ \"БелГУ\"",
   "Название доклада": "ОБ ЭЛЛИПТИЧЕСКОМ УРАВНЕНИЕ В НЕТРИВИАЛЬНОМ КОНУСЕ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Тухлиев Камаридин, Эшонкулов Рустамжон Нурмаматович",
   "Место работы (учебы)": "Таджикистан, Худжанд, ХГУ им. академика Б. Гафурова",
   "Название доклада": "СРЕДНЕКВАДРАТИЧЕСКОЕ ПРИБЛИЖЕНИЕ ФУНКЦИЙ НА ВСЕЙ ОСИ ПОЛИНОМАМИ ЭРМИТА",
   "Секция": "КФА"
 },
 {
   "ФИО": "Фазуллин Зиганур Юсупович",
   "Место работы (учебы)": "Уфа, Уфимский университет науки и технологий",
   "Название доклада": "ОБ ОДНОМ ИНВАРИАНТЕ ФОРМУЛ СЛЕДОВ В „СРЕДНЕМ“",
   "Секция": "СТО"
 },
 {
   "ФИО": "Файрузов Махмут Эрнстович",
   "Место работы (учебы)": "Уфа, Уфимский университет науки и технологий",
   "Название доклада": "ИССЛЕДОВАНИЕ ЗАДАЧИ ОПТИМАЛЬНОГО УПРАВЛЕНИЯ ДЛЯ НЕЛИНЕЙНОЙ ЭЛЛИПТИЧЕСКОЙ СИСТЕМЫ СО СМЕШАННЫМИ ГРАНИЧНЫМИ УСЛОВИЯМИ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Федоров В.Е., Вершинина Д. А.",
   "Место работы (учебы)": "Челябинск, ЧелГУ",
   "Название доклада": "УРАВНЕНИЯ С ПРОИЗВОДНОЙ РИМАНА — ЛИУВИЛЛЯ И ПРИНЦИП СУБОРДИНАЦИИ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Федоров Константин Михайлович,\n Ганопольский Родион Михайлович,\n Гильманов Александр Янович,\n Жонин Александр Владимирович, Фоломеев Алексей Евгеньевич",
   "Место работы (учебы)": "Тюмень, Тюменский госуниверситет,\n Тюменский госуниверситет,\n Тюменский госуниверситет,\n Уфа, ООО АЛТИМ,\n Ижевск, ЗАО ИННЦ",
   "Название доклада": "Определение и использование фрактальных характеристик червоточин при моделировании процесса выщелачивания карбонатов кислотой",
   "Секция": "ММ"
 },
 {
   "ФИО": "Филин Николай Владимирович",
   "Место работы (учебы)": "Челябинск, ЧелГУ",
   "Название доклада": "ОБ ОДНОЗНАЧНОЙ РАЗРЕШИМОСТИ КВАЗИЛИНЕЙНОГО УРАВНЕНИЯ С РАСПРЕДЕЛЕННЫМИ ПРОИЗВОДНЫМИ ГЕРАСИМОВА — КАПУТО",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Хабибуллин Булат Нурмиевич",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН",
   "Название доклада": "КОНЕЧНО ПОРОЖДЁННЫЕ ИДЕАЛЫ И ПОДМОДУЛИ В КЛАССАХ ГОЛОМОРФНЫХ ФУНКЦИЙ",
   "Секция": "КФА"
 },
 {
   "ФИО": "Харук Наталья Вячеславовна",
   "Место работы (учебы)": "Санкт-Петербург, ПОМИ РАН",
   "Название доклада": "О КВАНТОВОМ УРАВНЕНИИ ДВИЖЕНИЯ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Хасанов Юсуфали Хасанович,\n Талбакзода Фарходджон Махмадшо",
   "Место работы (учебы)": "Таджикистан, Душанбе, Российско-Таджикский Славянский университет,\n Душанбе, ТГПУ",
   "Название доклада": "О достаточных условиях сходимости рядов Фурье почти-периодических функций",
   "Секция": "КФА"
 },
 {
   "ФИО": "Хашпер Белла Леонидовна, Гиззатова Эльвира Раисовна, Юнусова Дарья Сергеевна",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "АНАЛИЗ МАТРИЦЫ СКОРОСТЕЙ ДЛЯ ВЫЯВЛЕНИЯ ОСОБЕННОСТЕЙ ДИНАМИЧЕСКИХ СВОЙСТВ СИСТЕМЫ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Худалов Марат Захарович",
   "Место работы (учебы)": "Владикавказ, Северо-Осетинский Государственный Университет",
   "Название доклада": "МЕТОД РОТЭ ДЛЯ УРАВНЕНИЯ ТЕПЛОПРОВОДНОСТИ С ОПЕРАТОРОМ ДРОБНОГО ДИФФЕРЕНЦИРОВАНИЯ ГЕРАСИМОВА-КАПУТО",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Хуснияров Руслан Маратович, Башмаков Рустэм Абдрауфович, Нагаева Зиля Мунировна",
   "Место работы (учебы)": "Уфа, УУНиТ,\n УУНиТ,\n УГНТУ",
   "Название доклада": "ИЗМЕНЕНИЕ ДАВЛЕНИЯ В КОРОТКОЙ ТРЕЩИНЕ ГРП",
   "Секция": "ММ"
 },
 {
   "ФИО": "Щиголев Д.,\n Хисамиев А.,\n Великанов П.",
   "Место работы (учебы)": "Казань, Казанский национальный исследовательский технический университет им. А.Н. Туполева-КАИ",
   "Название доклада": "Решение систем обыкновенных дифференциальных уравнений с переменными коэффициентами с помощью метода граничных элементов для расчета авиационных дисков",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Чебакова Виолетта Юрьевна,\n Кашапов Ленар Наилевич",
   "Место работы (учебы)": "Казань, Казанский (Приволжский) федеральный университет,\n Казань, ИПИ АН РТ",
   "Название доклада": "ИССЛЕДОВАНИЕ ПРОЦЕССОВ В ЭЛЕКТРОЛИТНЫХ СИСТЕМАХ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Черданцев Игорь Юрьевич,\n Васенина Наталья Анатольевна,\n Зеркина Анастасия Васильевна",
   "Место работы (учебы)": "Уфа, Уфимский университет науки и технологий",
   "Название доклада": "Матричный аналог второго уравнения Пенлеве",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Чилина Екатерина Евгеньевна",
   "Место работы (учебы)": "Нижний Новгород, НИУ ВШЭ",
   "Название доклада": "ГОМЕОМОРФИЗМЫ ТРЁХМЕРНЫХ ОРИЕНТИРУЕМЫХ МНОГООБРАЗИЙ С ПСЕВДОАНОСОВСКИМИ АТТРАКТОРАМИ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Шавлуков Азамат Мавлетович",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН",
   "Название доклада": "О ТИПИЧНЫХ СИНГУЛЯРНОСТЯХ  D4, D5  И E6 РЕШЕНИЙ ДВУМЕРНОГО ВОЛНОВОГО УРАВНЕНИЯ",
   "Секция": "НУ"
 },
 {
   "ФИО": "Шарипов Руслан Абдулович",
   "Место работы (учебы)": "Уфа, Уфимский университет науки и технологий",
   "Название доклада": "Движение релятивистских упругих сред в модели вселенной как 3D-браны",
   "Секция": "НУ"
 },
 {
   "ФИО": "Шерстюков Владимир Борисович",
   "Место работы (учебы)": "Москва, МГУ им. М.В. Ломоносова",
   "Название доклада": "Асимптотические свойства специальных тригонометрических последовательностей",
   "Секция": "КФА"
 },
 {
   "ФИО": "Шарипов Б.,\n Джумаев Э.Х.",
   "Место работы (учебы)": "Таджикистан, Душанбе, ТГФЭУ\n Душанбе, МГУ имени М.В. Ломоносова",
   "Название доклада": "Об одном классе системы дифференциальных уравнений с сингулярными точками в комплексной плоскости",
   "Секция": "НУ"
 },
 {
   "ФИО": "У Цзинсюй\n Ин Юйвэй\n Турди Умайр\n Хэ Ифань",
   "Место работы (учебы)": "Москва, МГУ им. М.В. Ломоносова,\n Франция, Париж, Парижская политехническая школа,\n Китай, Урумчи, Синьцзянский инженерный институт,\n Китай, Ланьчжоу, Ланьчжоуский университет",
   "Название доклада": "ТЕРМОДИНАМИЧЕСКИЕ ФАЗОВЫЕ ПЕРЕХОДЫ ЧЁРНЫХ ДЫР С ЭКСТРЕМАЛЬНЫМ ОТНОШЕНИЕМ МАСС И ИХ ГРАВИТАЦИОННО-ВОЛНОВЫЕ СИГНАТУРЫ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Юлмухаметов Ринад Салаватович,\n Исаев Константин Петрович",
   "Место работы (учебы)": "Уфа, ИМВЦ УФИЦ РАН\n Уфа, Уфимский университет науки и технологий",
   "Название доклада": "ОПИСАНИЕ НАИМЕНЬШИХ МОДУЛЕЙ, СОДЕРЖАЩИХ ВЕСОВОЕ ПРОСТРАНСТВО ЦЕЛЫХ ФУНКЦИЙ МНОГИХ ПЕРЕМЕННЫХ",
   "Секция": "КФА"
 },
 {
   "ФИО": "Юмагулов  М.Г.,  Васенина Н.А.",
   "Место работы (учебы)": "Уфа, УУНиТ",
   "Название доклада": "ОБ УСЛОВИЯХ БИФУРКАЦИИ ТЬЮРИНГА-ХОПФА В СИСТЕМАХ ТИПА “РЕАКЦИЯ-ДИФФУЗИЯ”",
   "Секция": "НУ"
 },
 {
   "ФИО": "Юмагулов М.Г., Ибрагимова Л.С.,  Орипов Т.С .",
   "Место работы (учебы)": "Уфа, УУНиТ, Uzbekistan, Denau,\n Denau Institute of Entrepreneurship and Pedagogy",
   "Название доклада": "ГАМИЛЬТОНОВЫ СТРУКТУРЫ ДЛЯ\n ПЕРИОДИЧЕСККИХ ДИФФЕРЕНЦИАЛЬНЫХ\n УРАВНЕНИЙ С ПРОИЗВОДНЫМИ ЧЕТНЫХ\n ПОРЯДКОВ, ЗАВИСЯЩИХ ОТ МАЛОГО ПАРАМЕТРА",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Юсупов Гулзорхон Амиршоевич",
   "Место работы (учебы)": "Таджикистан, Душанбе, S. Ayni Tajik State Pedagogical University",
   "Название доклада": "СОВМЕСТНОЕ ПРИБЛИЖЕНИЕ НЕКОТОРЫХ КЛАССОВ ФУНКЦИЙ В ПРОСТРАНСТВЕ L2",
   "Секция": "КФА"
 },
 {
   "ФИО": "Ядрихинский Христофор Васильевич",
   "Место работы (учебы)": "Якутск, СВФУ",
   "Название доклада": "ГЕНЕРАТОРЫ ГРУПП ПРЕОБРАЗОВАНИЙ ЭКВИВАЛЕНТНОСТИ УРАВНЕНИЯ С ДРОБНОЙ ПРОИЗВОДНОЙ ГЕРАСИМОВА — КАПУТО ПО ПРОСТРАНСТВЕННОЙ ПЕРЕМЕННОЙ",
   "Секция": "ДУ"
 },
 {
   "ФИО": "Ячиков Игорь Михайлович,\n Белых Дарья Васильевна,\n Шафиков Тимур Ильдусович",
   "Место работы (учебы)": "Челябинск, ЮУрГУ, \n Новотроицк, НФ НИТУ «МИСИС»,\n Челябинск, ЮУрГУ",
   "Название доклада": "Математические модели по определению коэффициента теплопередачи через медную стенку слябового кристаллизатора МНЛЗ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Ячиков Игорь Михайлович, Шафиков Тимур Ильдусович, Белых Дарья Васильевна, Суслова Татьяна Ивановна,  Журавлева София Алексеевна, Сулименко Максим Витальевич",
   "Место работы (учебы)": "Челябинск, ЮУрГУ,  ЮУрГУ, Новотроицк, НФ НИТУ «МИСИС», Челябинск, ЮУрГУ,  ЮУрГУ, ЮУрГУ",
   "Название доклада": "АДАПТАЦИЯ МАТЕМАТИЧЕСКОЙ МОДЕЛИ РАСПРЕДЕЛЕНИЯ ТЕПЛОВОГО ПОТОКА К СТЕНКЕ КРИСТАЛЛИЗАТОРА МНЛЗ НА ОСНОВЕ ПРОМЫШЛЕННЫХ ДАННЫХ",
   "Секция": "ММ"
 },
 {
   "ФИО": "Arabov Mullosharaf Kurbonovich",
   "Место работы (учебы)": "Казань, Казанский (Приволжский) федеральный университет",
   "Название доклада": "PHYSICS-INFORMED NEURAL NETWORKS FOR LIMIT-CYCLE ANALYSIS IN NONLINEAR DYNAMICAL SYSTEMS WITH ABSOLUTE-VALUE NONLINEARITY",
   "Секция": "НУ"
 },
 {
   "ФИО": "Viktor I. Korzyuk,\n Jan V. Rudzko",
   "Место работы (учебы)": "Белоруссия, Минск, Belarusian State University,\n Белоруссия, Минск, Institute of Mathematics of the National Academy of Sciences of Belarus",
   "Название доклада": "CLASSICAL SOLUTION OF THE CAUCHY PROBLEM FOR A SEMILINEAR HYPERBOLIC EQUATION WHOSE OPERATOR IS A COMPOSITION OF FIRST-ORDER OPERATORS",
   "Секция": "НУ"
 },
 {
   "ФИО": "Chechkin Gregory A.",
   "Место работы (учебы)": "Москва, МГУ им. М.В. Ломоносова",
   "Название доклада": "ON THE HELMHOLTZ RESONATOR WITH MICROINHOMOGENEOUS STRUCTURE",
   "Секция": "СТО"
 },
 {
   "ФИО": "Kucharov Ramziddin Ruzimuradovich,\n Tuxtamurodova Tillohon Mansurjon kizi",
   "Место работы (учебы)": "Узбекистан, Ташкент, NUU",
   "Название доклада": "ON THE EXISTENCE OF THE EFIMOV EFFECT FOR A PARTIAL INTEGRAL OPERATOR OF THE FREDHOLM TYPE",
   "Секция": "СТО"
 },
 {
   "ФИО": "Husenov Behzod Erkin ugli (Хусенов Бехзод Эркин угли),\n Oripova Sadafbonu Qobil kizi",
   "Место работы (учебы)": "Узбекистан, Бухара, Department of Mathematical Analysis of Bukhara State University,\n Узбекистан, Бухара, Department of Mathematical Analysis, Bukhara State University",
   "Название доклада": "Kytmanov's method Carleman's formula for A(z)-analytic functions (Метод Кытманова формула Карлемана для A(z)-аналитических функций)",
   "Секция": "КФА"
 }
]